export const SCHEDULED_PROGRAMS_ACTION = 'SCHEDULED_PROGRAMS_ACTION';
export const SCHEDULED_PROGRAMS_SUCCESS_ACTION =
  'SCHEDULED_PROGRAMS_SUCCESS_ACTION';
export const SCHEDULED_PROGRAMS_FAILURE_ACTION =
  'SCHEDULED_PROGRAMS_FAILURE_ACTION';
